import React, { memo, useState } from 'react';
import { UpdateGmbLocationParams } from '../../../../requests/partner/gmb-locations';

import BaseRaw from './BaseRaw';
import LocationNameModal from '../form-modal/LocationNameModal';

type Props = {
  label: string;
  value: string;
  handleUpdate?: (params: UpdateGmbLocationParams) => Promise<void>;
  editable?: boolean;
};

const OpenInfoRaw: React.FC<Props> = (props) => {
  const editable = props.editable === undefined || props.editable ? true : false;
  const [isShow, setIsShow] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleModal = () => {
    setIsShow(!isShow);
  };
  const handleSubmit = async (params: UpdateGmbLocationParams): Promise<void> => {
    setIsLoading(true);
    try {
      if (props.handleUpdate !== undefined) await props.handleUpdate(params);
      setIsShow(!isShow);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <BaseRaw
        isLoading={isLoading}
        label={props.label}
        value={props.value || '未設定'}
        handleModal={editable ? handleModal : undefined}
      />
      {editable ? (
        <LocationNameModal
          isShow={isShow}
          label={props.label}
          value={props.value || '未設定'}
          handleModal={handleModal}
          handleUpdate={handleSubmit}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default memo(OpenInfoRaw);
